export default "__VITE_ASSET__77baf0c1__"